import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1100,
    width: '100%',
    margin: '0 auto',
  },
  section: {
    marginBottom: theme.spacing(1),
  },
  marginLeft: {
    marginLeft: theme.spacing(3)
  },
  rowSpace: {
    marginTop: theme.spacing(2),
  }
}))